"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { useWebViewAuthModal } from "@/hooks/client/useWebViewAuthModal";

const CTASection: React.FC = () => {
  const { handleClick, AuthModals } = useWebViewAuthModal();

  return (
    <div className="relative bg-background">
      <AuthModals />

      {/* Main content container */}
      <div className="relative flex w-full flex-col items-center justify-center gap-16 pt-32">
        {/* Text container */}
        <div className="flex w-full flex-col items-center justify-center">
          <div className="w-full text-center font-figtree text-5xl font-semibold leading-none text-foreground lg:text-8xl lg:leading-none">
            Travel Upgraded
            <br />
            with{" "}
            {/* eslint-disable-next-line local-rules/enforce-semantic-colors -- decorative landing page text gradient */}
            <span className="inline-block bg-gradient-to-r from-[#ffd4b6] via-[#fff3ea] to-[#c65708] bg-clip-text text-transparent">
              Gondola
            </span>
          </div>
        </div>

        {/* CTA Button */}
        <Button
          onClick={handleClick}
          variant="orange-gradient"
          className="font-figtree text-lg leading-7 text-pure-white"
        >
          Start earning more
        </Button>
      </div>

      {/* Video container - shows only bottom half */}
      <div className="relative top-1 h-[400px] w-full overflow-hidden lg:h-[700px]">
        <div className="absolute inset-0 h-[200%] w-full" style={{ top: "0%" }}>
          <video
            autoPlay
            loop
            muted
            playsInline
            className="h-full w-full object-cover"
          >
            <source
              src="https://assets.gondola.ai/earth_rotating.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        {/* Radial gradient overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(284% 86.63% at 50.03% 100%, #020817 30%, rgba(2, 8, 23, 0.00) 100%)",
          }}
        />
      </div>
    </div>
  );
};

export default CTASection;
